export const CREATOR_NAV_OPEN_EVENT = 'dashboard-open-creator-nav'
